// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__brC1j","dotFlashing":"Loader_dotFlashing__AH0M1"};